import * as v from 'valibot';
import Ajax from '../util/ajax';
import { hastaReceiverSchema } from '../types/HastaReceiver';
import { hastaReceiverUpdated } from '../reducers/hastaReceiversSlice';
export function saveHastaReceiver(r, okCallback, errorCallback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/hasta-receiver/' + r.id;
        const obj = Object.assign(Object.assign({}, r), { codes: JSON.stringify(r.codes) });
        ajax.post(url, obj, data => {
            const res = v.safeParse(hastaReceiverSchema, data);
            if (res.success) {
                dispatch(hastaReceiverUpdated(res.output));
                okCallback();
            }
            else {
                console.error(v.summarize(res.issues));
                if (errorCallback != undefined) {
                    errorCallback();
                }
            }
        });
    };
}
